import { PortalType } from "@studyportals/domain-client";
import { FilterType } from "@studyportals/omnisearch-interfaces";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";
import { IExtendedFilterValue } from "@app/interfaces/dtos/IExtendedFilterValue";
import { RouteLocation } from "vue-router";

export class EducationalLevelFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.EDUCATION_LEVEL;
	public isMultiSelect = false;
	private static instance: EducationalLevelFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{
			id: PortalType.MASTER,
			virtualPath: "master",
			name: "Master",
			portalTypes: [PortalType.DISTANCE_LEARNING],
		},
		{
			id: PortalType.BACHELOR,
			virtualPath: "bachelor",
			name: "Bachelor",
			portalTypes: [PortalType.DISTANCE_LEARNING],
		},
		{
			id: PortalType.PHD,
			virtualPath: "phd",
			name: "PhD",
			portalTypes: [PortalType.DISTANCE_LEARNING],
		},
		{
			id: PortalType.SHORT,
			virtualPath: "course",
			name: "Short course",
			portalTypes: [PortalType.DISTANCE_LEARNING],
		},
		{
			id: PortalType.DISTANCE_LEARNING,
			virtualPath: "distance-learning",
			name: "Online",
			portalTypes: []
		},
	];

	public override isMandatory(portalType: PortalType): boolean {
		return portalType !== PortalType.DISTANCE_LEARNING;
	}

	public static getInstance(): EducationalLevelFilterMapper {
		if (!EducationalLevelFilterMapper.instance) {
			EducationalLevelFilterMapper.instance = new EducationalLevelFilterMapper();
		}
		return EducationalLevelFilterMapper.instance;
	}

	protected override getFilterValuesFromRouteParams(valueSet: Set<IExtendedFilterValue>, route: RouteLocation): Set<IExtendedWithPortalTypeFilterValue> {
		const paramValue = route.params?.[this.filterType];

		if (paramValue === "distance-learning") {
			return valueSet;
		}

		return super.getFilterValuesFromRouteParams(valueSet, route);
	}

	private constructor() {
		super();
	}
}
